module.exports = __webpack_public_path__ + "static/cam-head-96aad0a500f93415070949ff374f53a6.png";